// Shared presentation helpers for the stage comments tab and the all-comments modal.
const AVATAR_PALETTE = ['#7C3AED', '#0D9488', '#2563EB', '#EA580C', '#DB2777', '#16A34A']

export function initials (name) {
  return (name || '?').trim().charAt(0).toUpperCase() || '?'
}

export function avatarColor (name) {
  let hash = 0
  for (let i = 0; i < (name || '').length; i++) hash = (hash * 31 + name.charCodeAt(i)) % AVATAR_PALETTE.length
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length]
}

export function relativeTime (ts) {
  const diffMs = Date.now() - ts
  const mins = Math.floor(diffMs / 60000)
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}d ago`
  return new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}



// WEBPACK FOOTER //
// ./src/components/user-journey/journey-flow/commentDisplay.js